import React from 'react'
import { css } from '@emotion/core'

type GuestInfoCellProps = {
  guestName: string
  currentNights: number
  totalNights: number
}

export const GuestInfoCell: React.FC<GuestInfoCellProps> = ({ guestName, currentNights, totalNights }) => {
  return (
    <>
      {/* 宿泊者名を表示 */}
      <div css={wrapTextStyle}>{guestName || '-'}</div>
      {/* 現在の泊数 / 総泊数を表示（例: 2/3） */}
      <div css={nightsInfoStyle}>{`${currentNights}/${totalNights}`}</div>
    </>
  )
}

const wrapTextStyle = css({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

const nightsInfoStyle = css({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: '#A3A3A3',
  paddingTop: 8,
})
